import { cosmoAPI } from "@/core/Api/cosmoAxiosInstance";

export default {
  postImpersona(payload) {
    return cosmoAPI.post("/user/impersona/", {
      ...payload,
    });
  },
};
